var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#506293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d4c76"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_11174",
    x: 4.924,
    y: 6.477,
    width: 22.15,
    height: 18.047,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0080ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030fa"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_59477",
    x: 2.924,
    y: 4.977,
    width: 22.15,
    height: 18.047,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc31f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_63399",
    x: 2.924,
    y: 4.977,
    width: 22.15,
    height: 18.047,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48211",
    "data-name": "Group 48211",
    transform: "translate(14455 15718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48210",
    "data-name": "Group 48210"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25790",
    "data-name": "Rectangle 25790",
    width: 30,
    height: 30,
    transform: "translate(-14455 -15718)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48209",
    "data-name": "Group 48209",
    transform: "translate(-14480.26 -16103.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8480",
    "data-name": "Group 8480",
    transform: "translate(30.684 392.736)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.42, -7.48)",
    filter: "url(#Path_11174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11174-2",
    "data-name": "Path 11174",
    d: "M39.575,44.6a.9.9,0,0,1,.862.808h4.394V44.38a1.336,1.336,0,0,0-1.28-1.386h-.388V40.759a4.03,4.03,0,0,0-1.051-2.754,3.435,3.435,0,0,0-2.48-1.139.186.186,0,0,0-.049,0,3.439,3.439,0,0,0-2.542,1.141,4.036,4.036,0,0,0-1.054,2.754v2.235H35.6a1.336,1.336,0,0,0-1.28,1.386v1.032h4.394A.9.9,0,0,1,39.575,44.6Zm-2.538-3.845a2.858,2.858,0,0,1,.746-1.95A2.437,2.437,0,0,1,39.533,38h.04a2.429,2.429,0,0,1,1.8.806,2.851,2.851,0,0,1,.744,1.949v2.235H37.038ZM47.4,45.9H31.747A1.827,1.827,0,0,0,30,47.788v2.23a1.827,1.827,0,0,0,1.747,1.892H47.4a1.826,1.826,0,0,0,1.747-1.892v-2.23A1.826,1.826,0,0,0,47.4,45.9Zm1.13,4.122a1.181,1.181,0,0,1-1.13,1.223H31.747a1.181,1.181,0,0,1-1.13-1.223v-2.23a1.181,1.181,0,0,1,1.13-1.223H47.4a1.181,1.181,0,0,1,1.13,1.223Z",
    transform: "translate(-24.58 -29.39)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11177",
    "data-name": "Path 11177",
    d: "M47.4,58.638H38.792a20.371,20.371,0,0,1-3.239,0H31.747A1.815,1.815,0,0,0,30,60.51v2.206a1.815,1.815,0,0,0,1.747,1.872H47.4a1.815,1.815,0,0,0,1.747-1.872V60.51A1.815,1.815,0,0,0,47.4,58.638Zm1.13,4.078a1.173,1.173,0,0,1-1.13,1.21H31.747a1.173,1.173,0,0,1-1.13-1.21V60.51a1.173,1.173,0,0,1,1.13-1.21H47.4a1.173,1.173,0,0,1,1.13,1.21Z",
    transform: "translate(-30 -49.541)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.42, -7.48)",
    filter: "url(#Path_59477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59477-2",
    "data-name": "Path 59477",
    d: "M39.575,44.6a.9.9,0,0,1,.862.808h4.394V44.38a1.336,1.336,0,0,0-1.28-1.386h-.388V40.759a4.03,4.03,0,0,0-1.051-2.754,3.435,3.435,0,0,0-2.48-1.139.186.186,0,0,0-.049,0,3.439,3.439,0,0,0-2.542,1.141,4.036,4.036,0,0,0-1.054,2.754v2.235H35.6a1.336,1.336,0,0,0-1.28,1.386v1.032h4.394A.9.9,0,0,1,39.575,44.6Zm-2.538-3.845a2.858,2.858,0,0,1,.746-1.95A2.437,2.437,0,0,1,39.533,38h.04a2.429,2.429,0,0,1,1.8.806,2.851,2.851,0,0,1,.744,1.949v2.235H37.038ZM47.4,45.9H31.747A1.827,1.827,0,0,0,30,47.788v2.23a1.827,1.827,0,0,0,1.747,1.892H47.4a1.826,1.826,0,0,0,1.747-1.892v-2.23A1.826,1.826,0,0,0,47.4,45.9Zm1.13,4.122a1.181,1.181,0,0,1-1.13,1.223H31.747a1.181,1.181,0,0,1-1.13-1.223v-2.23a1.181,1.181,0,0,1,1.13-1.223H47.4a1.181,1.181,0,0,1,1.13,1.223Z",
    transform: "translate(-24.58 -29.39)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3944",
    "data-name": "Rectangle 3944",
    d: "M.267,0h1.6a.267.267,0,0,1,.267.267v0a.267.267,0,0,1-.267.267H.267A.267.267,0,0,1,0,.267v0A.267.267,0,0,1,.267,0Z",
    transform: "translate(15.309 13.1)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.42, -7.48)",
    filter: "url(#Path_63399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63399-2",
    "data-name": "Path 63399",
    d: "M39.575,44.6a.9.9,0,0,1,.862.808h4.394V44.38a1.336,1.336,0,0,0-1.28-1.386h-.388V40.759a4.03,4.03,0,0,0-1.051-2.754,3.435,3.435,0,0,0-2.48-1.139.186.186,0,0,0-.049,0,3.439,3.439,0,0,0-2.542,1.141,4.036,4.036,0,0,0-1.054,2.754v2.235H35.6a1.336,1.336,0,0,0-1.28,1.386v1.032h4.394A.9.9,0,0,1,39.575,44.6Zm-2.538-3.845a2.858,2.858,0,0,1,.746-1.95A2.437,2.437,0,0,1,39.533,38h.04a2.429,2.429,0,0,1,1.8.806,2.851,2.851,0,0,1,.744,1.949v2.235H37.038ZM47.4,45.9H31.747A1.827,1.827,0,0,0,30,47.788v2.23a1.827,1.827,0,0,0,1.747,1.892H47.4a1.826,1.826,0,0,0,1.747-1.892v-2.23A1.826,1.826,0,0,0,47.4,45.9Zm1.13,4.122a1.181,1.181,0,0,1-1.13,1.223H31.747a1.181,1.181,0,0,1-1.13-1.223v-2.23a1.181,1.181,0,0,1,1.13-1.223H47.4a1.181,1.181,0,0,1,1.13,1.223Z",
    transform: "translate(-24.58 -29.39)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59471",
    "data-name": "Path 59471",
    d: "M36.7,63.543h-.572l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.117.117,0,0,0-.165,0l-.45.449V62.59a.117.117,0,0,0-.117-.117h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.117.117,0,0,0-.166,0l-.215.215a.118.118,0,0,0,0,.167l.4.393h-.577a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117h.57l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117h.3a.117.117,0,0,0,.117-.117v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.117.117,0,0,0,0-.166l-.413-.418H36.7a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,36.7,63.543Z",
    transform: "translate(-1.762 340.934)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59472",
    "data-name": "Path 59472",
    d: "M45.827,63.543h-.572l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.118.118,0,0,0-.166,0l-.45.449V62.59a.117.117,0,0,0-.117-.117h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.117.117,0,0,0-.166,0l-.215.215a.117.117,0,0,0,0,.167l.4.393h-.576a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117h.57l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117h.3a.117.117,0,0,0,.117-.117v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.118.118,0,0,0,0-.166l-.413-.418h.57a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,45.827,63.543Z",
    transform: "translate(-7.558 340.934)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59474",
    "data-name": "Path 59474",
    d: "M54.951,63.543h-.573l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.118.118,0,0,0-.166,0l-.45.449V62.59a.117.117,0,0,0-.117-.117h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.117.117,0,0,0-.166,0l-.215.215a.117.117,0,0,0,0,.167l.4.393h-.576a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117h.57l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117h.3A.117.117,0,0,0,54,65.03v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.118.118,0,0,0,0-.166l-.413-.418h.57a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,54.951,63.543Z",
    transform: "translate(-13.224 340.934)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59473",
    "data-name": "Path 59473",
    d: "M64.073,63.543H63.5l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.117.117,0,0,0-.165,0l-.45.449V62.59A.117.117,0,0,0,63,62.473h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.116.116,0,0,0-.165,0l-.216.215a.118.118,0,0,0,0,.167l.4.393h-.576a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117H62.2l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117H63a.117.117,0,0,0,.117-.117v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.117.117,0,0,0,0-.166l-.413-.418h.57a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,64.073,63.543Z",
    transform: "translate(-18.89 340.934)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63395",
    "data-name": "Path 63395",
    d: "M36.7,63.543h-.572l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.117.117,0,0,0-.165,0l-.45.449V62.59a.117.117,0,0,0-.117-.117h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.117.117,0,0,0-.166,0l-.215.215a.118.118,0,0,0,0,.167l.4.393h-.577a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117h.57l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117h.3a.117.117,0,0,0,.117-.117v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.117.117,0,0,0,0-.166l-.413-.418H36.7a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,36.7,63.543Z",
    transform: "translate(-1.762 340.934)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63396",
    "data-name": "Path 63396",
    d: "M45.827,63.543h-.572l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.118.118,0,0,0-.166,0l-.45.449V62.59a.117.117,0,0,0-.117-.117h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.117.117,0,0,0-.166,0l-.215.215a.117.117,0,0,0,0,.167l.4.393h-.576a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117h.57l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117h.3a.117.117,0,0,0,.117-.117v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.118.118,0,0,0,0-.166l-.413-.418h.57a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,45.827,63.543Z",
    transform: "translate(-7.558 340.934)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63397",
    "data-name": "Path 63397",
    d: "M54.951,63.543h-.573l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.118.118,0,0,0-.166,0l-.45.449V62.59a.117.117,0,0,0-.117-.117h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.117.117,0,0,0-.166,0l-.215.215a.117.117,0,0,0,0,.167l.4.393h-.576a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117h.57l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117h.3A.117.117,0,0,0,54,65.03v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.118.118,0,0,0,0-.166l-.413-.418h.57a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,54.951,63.543Z",
    transform: "translate(-13.225 340.934)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63398",
    "data-name": "Path 63398",
    d: "M64.073,63.543H63.5l.451-.447a.117.117,0,0,0,0-.166l-.216-.216a.117.117,0,0,0-.165,0l-.45.449V62.59A.117.117,0,0,0,63,62.473h-.3a.117.117,0,0,0-.117.117v.572l-.4-.4a.116.116,0,0,0-.165,0l-.216.215a.118.118,0,0,0,0,.167l.4.393h-.576a.117.117,0,0,0-.117.117v.3a.117.117,0,0,0,.117.117H62.2l-.359.365a.117.117,0,0,0,0,.166l.215.212a.117.117,0,0,0,.165,0l.362-.36v.571a.117.117,0,0,0,.117.117H63a.117.117,0,0,0,.117-.117v-.571l.415.414a.117.117,0,0,0,.165,0l.215-.212a.117.117,0,0,0,0-.166l-.413-.418h.57a.117.117,0,0,0,.117-.117v-.3A.117.117,0,0,0,64.073,63.543Z",
    transform: "translate(-18.891 340.934)",
    fill: "url(#linear-gradient-4)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePw);
export default __webpack_public_path__ + "static/media/change-pw.21092558.svg";
export { ForwardRef as ReactComponent };